import { LAYERS } from './model'

// Scene model → display tree. One Sprite per model item, in LAYERS order,
// tagged `gate1 = { key, state }` so verify.js can read back what was drawn.
// `pixi` supplies Container/Sprite (real PixiJS on device, stand-ins in Jest);
// `textures.get(name)` returns the texture for an item's `tex`.
export function buildScene(model, { pixi, textures }) {
    const root = new pixi.Container()
    root.label = 'gate1-scene'
    const layers = {}
    for (const name of LAYERS) {
        const c = new pixi.Container()
        c.label = `layer:${name}`
        layers[name] = c
        root.addChild(c)
    }
    for (const it of model) {
        const tex = textures.get(it.tex)
        const sp = new pixi.Sprite(tex)
        sp.anchor?.set?.(0.5)
        // Atlas textures are 2x (or 256 px) larger than shown: size to screen.
        if (tex?.gate1Size) { sp.width = tex.gate1Size.w; sp.height = tex.gate1Size.h }
        sp.position.set(it.x, it.y)
        sp.gate1 = { key: it.key, state: it.state }
        layers[it.kind].addChild(sp)
    }
    return { root, layers }
}
